// extracted by mini-css-extract-plugin
export var explainable = "_bo-a";
export var printerCard = "_bo-1";
export var printerCardConfigured = "_bo-2";
export var printerCardError = "_bo-3";
export var printerCardsContainer = "_bo-0";
export var printerIcon = "_bo-8";
export var printerIconConfigured = "_bo-5";
export var printerIconContainer = "_bo-4";
export var printerIconError = "_bo-6";
export var printerIconUnconfigured = "_bo-7";
export var workstationsTableCard = "_bo-9";